import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

export class ChangeTariffAnalytics extends BaseAnalytics {
    constructor(category = 'change_tariff') {
        super();
        this.category = category;
    }

    confirmTariffChangingError() {
        this.send('confirm_tariff_changing', 'error');
    }

    confirmTariffChangingSuccess() {
        this.send('confirm_tariff_changing', 'success');
    }

    confirmTariff100plusChangingSuccess() {
        this.send('confirm_tariff100plus_changing', 'success');
    }
}
